<script lang="ts">
  import { fly } from "svelte/transition";
  import { onMount, onDestroy } from "svelte";

  interface Props {
    useScroll?: boolean;
    class?: string;
    children?: import("svelte").Snippet;
  }

  let { useScroll = true, class: className, children }: Props = $props();
  let scroll: any;

  onMount(() => {
    if (useScroll) {
      scroll = setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 300);
    }
  });
  onDestroy(() => {
    if (useScroll) {
      clearTimeout(scroll);
    }
  });
</script>

<div
  in:fly={{ x: 500, duration: 800 }}
  out:fly={{ x: -500, duration: 800 }}
  class="row-start-1 col-start-1 {className}"
>
  {@render children?.()}
</div>
